import {
  CertificationCreateInput,
  CreateCertificationMutation,
  CreateCertificationMutationVariables,
} from '__generated__/graphql';
import { CREATE_CERTIFICATION_MUTATION } from 'apollo/mutations/certification.mutations';
import useGraphQLClient from 'hooks/graphql/useGraphQLClient/useGraphQLClient';
import { isNil } from 'lodash';
import { useCallback } from 'react';

export const useCreateCertification = () => {
  const client = useGraphQLClient();

  const createCertification = useCallback(
    async (certification: CertificationCreateInput) => {
      const result = await client.request<CreateCertificationMutation, CreateCertificationMutationVariables>({
        document: CREATE_CERTIFICATION_MUTATION,
        variables: {
          certification,
        },
      });

      if (isNil(result.createCertification)) {
        throw Error(`result was ${result.createCertification}`);
      }

      return result.createCertification;
    },
    [client]
  );

  return createCertification;
};
